export const LIFECYCLE_STAGES = [
  {
    key: 'lead',
    label: 'Lead',
    color: '#6b7280',
    bgClass:
      'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300',
  },
  {
    key: 'qualificado',
    label: 'Qualificado',
    color: '#3b82f6',
    bgClass: 'bg-blue-100 text-blue-700 dark:bg-blue-500/20 dark:text-blue-300',
  },
  {
    key: 'negociacao',
    label: 'Negociação',
    color: '#f59e0b',
    bgClass:
      'bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300',
  },
  {
    key: 'cliente',
    label: 'Cliente',
    color: '#16a34a',
    bgClass:
      'bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-300',
  },
  {
    key: 'inativo',
    label: 'Inativo',
    color: '#ef4444',
    bgClass: 'bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-300',
  },
];

export const LIFECYCLE_MAP = Object.fromEntries(
  LIFECYCLE_STAGES.map(s => [s.key, s])
);

export const COMPANY_SIZES = [
  { key: 'mei', label: 'MEI' },
  { key: 'micro', label: 'Micro' },
  { key: 'pequena', label: 'Pequena' },
  { key: 'media', label: 'Média' },
  { key: 'grande', label: 'Grande' },
];

export const COMPANY_SIZE_MAP = Object.fromEntries(
  COMPANY_SIZES.map(s => [s.key, s])
);

export const DEFAULT_SECTORS = [
  'Tecnologia',
  'Saúde',
  'Educação',
  'Financeiro',
  'Varejo',
  'Indústria',
  'Serviços',
  'Logística',
  'Agronegócio',
  'Imobiliário',
  'Alimentação',
  'Construção',
  'Energia',
  'Telecomunicações',
  'Jurídico',
  'Marketing',
  'Consultoria',
  'Automotivo',
  'Turismo',
  'Outro',
];
